import { TipoElementoRML } from "./ElementoRMLRecord";
import { URIAndTrace } from "@commons/mapping/URIAndTrace";

export type NomeCampiTotalizzabili = keyof (Pick<LavoratoreSingoloElementoRML, 'retribuzioneCompenso'> &
    Pick<LavoratoreSingoloElementoRML, 'retribuzioneNonAdeguata'> &
    Pick<LavoratoreSingoloElementoRML, 'sommaImportoVoci'> &
    Pick<LavoratoreSingoloElementoRML, 'sommaImportoVociNonAdeguata'>
    );

export interface LavoratoreRML extends URIAndTrace {
    idAziendaMaster: number;
    idDip: number;
    nominativo: string; // SOLO per PVA!
    settoreCCNL: string;
    codContrattoUNILAV: string;
    codContrattoCCNL: string;
    codLivello: string;
    retribuzioneCompenso: number;
    codiceFiscale: string;
    decorrenza: string;
    retribuzioneNonAdeguata: number;
    codTabella: string;
    codQualifica: string;
    descrizioneQualifica: string;
    rilevazioneNonCompleta: boolean;
    diversaRispettoRilevazionePrec: boolean;
    diffInMesiConRilevazionePrec: number;
    divisoreOrario: number;
    percentualePT: number;
    pagaOraria: boolean; // true=>Paga oraria, false=>Paga mensile

    sommaImportoVoci: number;
    sommaImportoVociNonAdeguata: number;
}

export class LavoratoreRML {
    static valorizzaElemento = (retribOraria: boolean, nomeRetribuzione: NomeCampiTotalizzabili, item: LavoratoreRML) => {
        if (retribOraria) {
            if (item.pagaOraria) {
                return item[nomeRetribuzione];
            } else {
                if (item.divisoreOrario) {
                    return item[nomeRetribuzione] / item.divisoreOrario;
                }
            }
            return null;
        } else
            return item[nomeRetribuzione];
    }
}

export interface LavoratoreSingoloElementoRML extends LavoratoreRML {
    sortOrder: number,
    descrizioneTabella: string | null,
    codElemento: string | null,
    descrizioneElemento: string | null,
    noteElemento: string | null,
    elementoDiscrezionale: boolean | null,
    tipo: TipoElementoRML | null,
}